import BookImg from "./img/book.png";
import clsx from 'clsx';

import './chapter-selection.css';

const ChapterSelection = ({ disableBtn, isMenuRetract, onClick }) => {

  return (
    <button
      className={clsx('chapter-selection-button', {
        'chapter-selection-button--show': !isMenuRetract,
      })}
      onClick={onClick}
      disabled={disableBtn}
      aria-label="Selecionar capítulo"
    >
      <img src={BookImg} className="chapter-selection-img" alt="" />
    </button>
  );
};

export default ChapterSelection;
